import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-textarea-autosize';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import {
  PluginInput,
  PluginTextareaWrapper,
  HeaderWrapper,
  TextWrapDescription,
  TextWrapSubheader,
  TextWrapSubheaderTwo,
} from './styles';

const PluginSelectionHeader = ({ title, placeholder, descriptionPlaceholder, templateTitle, templateDescription, value, descriptionValue, showDescriptionInput = true, onChange }) => (
  <HeaderWrapper>
    <TextWrapSubheader>
      {intl.formatMessage(title)}
    </TextWrapSubheader>
    <PluginInput
      name="name"
      placeholder={intl.formatMessage(placeholder)}
      type="text"
      value={value}
      fontSize={20}
      onChange={onChange}
    />
    { showDescriptionInput &&
      <PluginTextareaWrapper
        fontSize={16}
      >
        <TextareaAutosize
          name="description"
          placeholder={intl.formatMessage(descriptionPlaceholder)}
          value={descriptionValue}
          onChange={onChange}
        />
      </PluginTextareaWrapper>
    }
    <TextWrapSubheaderTwo>
      {intl.formatMessage(templateTitle)}
    </TextWrapSubheaderTwo>
    <TextWrapDescription>
      {intl.formatMessage(templateDescription)}
    </TextWrapDescription>
  </HeaderWrapper>
);

PluginSelectionHeader.propTypes = {
  title: PropTypes.object,
  templateTitle: PropTypes.object,
  templateDescription: PropTypes.object,
  placeholder: PropTypes.object,
  descriptionPlaceholder: PropTypes.object,
  value: PropTypes.string,
  descriptionValue: PropTypes.string,
  showDescriptionInput: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default PluginSelectionHeader;
